// One key per order attempt. Sending the same order again (after an error or
// a timeout) reuses the key, so the server answers with the order it already
// placed instead of placing a second one. Any change to what's being ordered
// starts a new attempt.
export function attemptKeyFor(ref, order) {
  const fingerprint = JSON.stringify(order);
  if (!ref.current || ref.current.fingerprint !== fingerprint) ref.current = { fingerprint, key: newKey() };
  return ref.current.key;
}

function newKey() {
  if (window.crypto && window.crypto.randomUUID) return window.crypto.randomUUID();
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;
}
